import { ChildProps } from '@/common/util/props'
import { HttpStatusCode } from '@/common/util/status'

import PageEditLoading from '@/components/view/molecules/loading/PageEditLoading'

import ErrorPage from '@/components/container/page/ErrorPage'

interface Props extends ChildProps {
  error: Response | { status: HttpStatusCode } | undefined
  data: any
  withSide?: boolean
  small?: boolean
}

const DetailPageLoader = ({ children, error, data, withSide = false, small = false }: Props) => {
  return (
    <>
      {error != undefined ? (
        <ErrorPage status={error.status} />
      ) : data === undefined ? (
        <PageEditLoading withSide={withSide} small={small} />
      ) : data === null ? (
        <ErrorPage status={HttpStatusCode.NOT_FOUND} />
      ) : (
        <>{children}</>
      )}
    </>
  )
}

export default DetailPageLoader
